export default __webpack_public_path__ + "static/rOrder-8f686453a95f49550b4a25b33942c527.png";